import { AxiosInstance } from "axios"
import { SubscriptionOrder } from "./subscriptionsTypes"

export enum CompanyReportsSubscriptionQuery {
    SUBSCRIPTIONS_FOR_COMPANY_REPORTS = "subscriptions-for-company-reports",
}

type SubscriptionsForCompanyParams = Readonly<{
    companyId: number
    orderId?: string
    subscriptionIds?: string
    startDate?: string
    endDate?: string
    merchantId?: string
    merchantIds?: string
    shopIds?: string
    customerId?: string
    userGroupId?: string
    email?: string
    paymentMethods?: string
    creditCardLast4?: string
}>

export type SubscriptionsForCompanyResponse = Readonly<{
    orders: SubscriptionOrder[]
}>

export async function fetchSubscriptionsForCompany(
    params: SubscriptionsForCompanyParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<SubscriptionsForCompanyResponse> {
    const { companyId, ...rest } = params
    const url = `/companies/${companyId}/accounting/subscriptions/orders`

    const { data } = await axios.get(url, {
        params: rest,
        signal,
    })

    return data
}
